import React, { useState } from 'react';
import { CalendarMonthView } from '../components/calendar/CalendarMonthView';
import { UpcomingEventsList } from '../components/calendar/UpcomingEventsList';
import { mockEvents } from '../data/mockEvents';
import { getHuecosDeOro } from '../utils/huecosDeOro';
import { ChevronLeft, ChevronRight, Plus } from 'lucide-react';
import { BookingModal } from '../components/booking/BookingModal';
export function Calendario() {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [view, setView] = useState<'Month' | 'Week' | 'Day' | 'Agenda'>('Month');
  const [isBookingOpen, setIsBookingOpen] = useState(false);
  const [selectedDateForBooking, setSelectedDateForBooking] = useState<Date | undefined>(undefined);
  // Mock data
  const events = mockEvents;
  const huecosDeOro = getHuecosDeOro(currentDate);
  const handlePrevMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1));
  };
  const handleNextMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1));
  };
  const handleToday = () => {
    setCurrentDate(new Date());
  };
  const monthNames = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
  return <div className="p-4 md:p-8 max-w-[1100px] mx-auto space-y-6 pb-24 md:pb-8 h-screen flex flex-col" data-id="element-609">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-610">
        <div className="flex items-center space-x-4" data-id="element-611">
          <h1 className="text-[28px] font-bold text-growthly-text" data-id="element-612">
            {monthNames[currentDate.getMonth()]} {currentDate.getFullYear()}
          </h1>
          <div className="flex items-center bg-growthly-surface border border-white/5 rounded-md" data-id="element-613">
            <button onClick={handlePrevMonth} className="p-2 hover:bg-white/5 transition-colors rounded-l-md" data-id="element-614">
              <ChevronLeft className="w-4 h-4 text-growthly-text" data-id="element-615" />
            </button>
            <button onClick={handleToday} className="px-3 py-2 text-[13px] font-medium text-growthly-text border-x border-white/5 hover:bg-white/5 transition-colors" data-id="element-616">
              Hoy
            </button>
            <button onClick={handleNextMonth} className="p-2 hover:bg-white/5 transition-colors rounded-r-md" data-id="element-617">
              <ChevronRight className="w-4 h-4 text-growthly-text" data-id="element-618" />
            </button>
          </div>
        </div>

        <div className="flex items-center space-x-3" data-id="element-619">
          <div className="flex bg-growthly-surface border border-white/5 rounded-md p-1" data-id="element-620">
            {['Month', 'Week', 'Day', 'Agenda'].map(v => <button key={v} onClick={() => setView(v as any)} className={`px-3 py-1 text-[12px] font-medium rounded transition-colors ${view === v ? 'bg-white/10 text-growthly-text' : 'text-growthly-muted hover:text-growthly-text'}`} data-id="element-621">
                {v === 'Month' ? 'Mes' : v === 'Week' ? 'Semana' : v === 'Day' ? 'Día' : 'Agenda'}
              </button>)}
          </div>
          <button onClick={() => {
          setSelectedDateForBooking(new Date());
          setIsBookingOpen(true);
        }} className="btn-primary flex items-center" data-id="element-622">
            <Plus className="w-4 h-4 mr-2" data-id="element-623" />
            Nuevo evento
          </button>
        </div>
      </div>

      <div className="flex-1 grid grid-cols-1 lg:grid-cols-4 gap-6 min-h-0" data-id="element-624">
        <div className="lg:col-span-3 h-full" data-id="element-625">
          <CalendarMonthView events={events} huecosDeOro={huecosDeOro} currentDate={currentDate} onSlotClick={date => {
          setSelectedDateForBooking(date);
          setIsBookingOpen(true);
        }} onEventClick={event => console.log('Open event details for', event)} data-id="element-626" />
        </div>
        <div className="hidden lg:block lg:col-span-1 h-full" data-id="element-627">
          <UpcomingEventsList events={events} data-id="element-628" />
        </div>
      </div>

      <BookingModal isOpen={isBookingOpen} onClose={() => setIsBookingOpen(false)} initialDate={selectedDateForBooking} data-id="element-629" />
    </div>;
}